// SH&Co. offer + cart extras:
// - CAD thresholds (free shipping, 30% tier) shown in the shopper's currency via Shopify.currency.rate:
//   [data-sh-cad] spans, "CA$N" in the announcement bar, the PDP tier box, the drawer bar.
//   Thresholds round UP so "over $72" is always true at checkout.
// - drawer bar: 30% goal first (subtotal before discounts), then free shipping (total after discounts)
// - "Upgrade" swaps a bracelet line for its ritual set; add-on "+" adds a pocket stone
// Sections re-render their HTML (drawer, PDP price on variant change), so a MutationObserver repaints.
// ponytail: '$' symbol assumes CAD/USD; use Shopify money format if more currencies get enabled.
(function () {
  function money(cents) {
    return '$' + (cents % 100 ? (cents / 100).toFixed(2) : Math.round(cents / 100));
  }
  function rate() {
    return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  }
  // CAD whole units -> shopper-currency cents, rounded up to a whole unit
  function goal(cad) {
    return Math.ceil(parseFloat(cad) * rate()) * 100;
  }
  function set(el, prop, val) {
    // only write when changed, or the MutationObserver below would loop
    if (el && el[prop] !== val) el[prop] = val;
  }

  function fillAmounts() {
    document.querySelectorAll('[data-sh-cad]').forEach(function (el) {
      set(el, 'textContent', money(goal(el.dataset.shCad)));
    });
    if (rate() !== 1) {
      document.querySelectorAll('.announcement-bar__message span').forEach(function (el) {
        set(el, 'textContent', el.textContent.replace(/CA\$(\d+)/g, function (m, n) { return money(goal(n)); }));
      });
    }
  }

  function cartSub() {
    var bar = document.querySelector('[data-sh-cbar]');
    return bar ? parseInt(bar.dataset.sub, 10) || 0 : 0;
  }
  function off(cents, pct) {
    return Math.round((cents * (100 - pct)) / 100);
  }

  // PDP / quick-add tier box: knows what is already in the cart
  function tierText(box, short) {
    var price = parseInt(box.dataset.price, 10);
    var target = goal(box.dataset.cad);
    var pct = parseInt(box.dataset.pct, 10);
    var inCart = cartSub();
    var left = target - inCart - price;
    if (inCart >= target) {
      return short ? pct + '% off is on your order' : pct + '% off is already on your order: this one is <b>' + money(off(price, pct)) + '</b>.';
    }
    if (left <= 0) {
      if (short) return 'Add this: ' + pct + '% off your order';
      return inCart > 0
        ? 'Add this and your whole order is ' + pct + '% off. No code needed.'
        : 'This one qualifies: <b>' + money(off(price, pct)) + '</b> instead of ' + money(price) + '. No code needed.';
    }
    if (short) return 'Add ' + money(left) + ' more for ' + pct + '% off';
    var line = inCart > 0
      ? 'You have ' + money(inCart) + ' in your cart. Add this + ' + money(left) + ' more for ' + pct + '% off.'
      : 'Add ' + money(left) + ' more and your whole order is ' + pct + '% off. No code needed.';
    if (box.dataset.setHint) line += ' Or pick the set: it gets ' + pct + '% off on its own.';
    return line;
  }

  function drawTiers() {
    document.querySelectorAll('[data-sh-tier]').forEach(function (box) {
      set(box.querySelector('[data-sh-tier-line]'), 'innerHTML', tierText(box));
    });
    // phone sticky bar: short version of its product's tier box
    document.querySelectorAll('[data-sh-tier-short]').forEach(function (el) {
      var box = document.querySelector('#price-' + el.dataset.shTierShort + ' [data-sh-tier]');
      set(el, 'textContent', box ? tierText(box, true) : '');
    });
  }

  // set prices: show the 30%-off price when the set alone crosses the line
  function draw30() {
    var o = window.shOffer;
    document.querySelectorAll('[data-sh30]').forEach(function (el) {
      var cents = parseInt(el.dataset.sh30, 10);
      var hit = o && cents >= goal(o.cad);
      set(el, 'innerHTML', hit ? '<s>' + money(cents) + '</s> <b>' + money(off(cents, o.pct)) + '</b>' : money(cents));
      var scope = el.closest('.sh-set__opt--set, [data-sh30-scope]');
      var tag = scope && scope.querySelector('[data-sh30-tag]');
      if (tag) set(tag, 'textContent', hit ? o.pct + '% off applied' : tag.dataset.sh30Tag);
    });
  }

  var was = null; // last goal state, to mark the moment a goal is reached
  var wonUntil = 0;
  var wonText = '';
  function drawBar() {
    var bar = document.querySelector('[data-sh-cbar]');
    if (!bar) {
      was = { tier: false, ship: false }; // no bar = empty cart, so a first add can still "unlock"
      return;
    }
    var sub = parseInt(bar.dataset.sub, 10) || 0;
    var total = parseInt(bar.dataset.total, 10) || 0;
    var pct = bar.dataset.pct;
    var tierGoal = pct ? goal(bar.dataset.tier) : 0;
    var shipGoal = parseFloat(bar.dataset.cad) > 0 ? goal(bar.dataset.cad) : 0;
    var now = { tier: !!tierGoal && sub >= tierGoal, ship: !!shipGoal && total >= shipGoal };
    if (was && ((now.tier && !was.tier) || (now.ship && !was.ship))) {
      wonUntil = Date.now() + 2500;
      wonText = now.tier && !was.tier
        ? '<strong>' + pct + '% off unlocked</strong> · you save ' + money(sub - off(sub, pct))
        : '<strong>Free shipping unlocked</strong>';
      setTimeout(paint, 2600);
    }
    was = now;
    var html, fill, title;
    if (tierGoal && sub < tierGoal) {
      html = "You're <strong>" + money(tierGoal - sub) + ' away</strong> from ' + pct + '% off your order';
      fill = sub / tierGoal;
      title = 'Add ' + money(tierGoal - sub) + ' to get ' + pct + '% off';
    } else if (shipGoal && total < shipGoal) {
      html = (pct ? '<strong>' + pct + '% off</strong> unlocked · ' : "You're ") + money(shipGoal - total) + ' more for free shipping';
      fill = total / shipGoal;
      title = 'Add ' + money(shipGoal - total) + ' for free shipping';
    } else {
      html = '<strong>' + (pct ? pct + '% off' + (shipGoal ? ' + free shipping' : '') : 'Free shipping') + '</strong> unlocked';
      fill = 1;
      title = 'Add a pocket stone';
    }
    var won = Date.now() < wonUntil;
    if (won) html = wonText;
    if (bar.classList.contains('is-won') !== won) bar.classList.toggle('is-won', won);
    set(bar.querySelector('[data-sh-cbar-msg]'), 'innerHTML', html);
    set(bar.querySelector('[data-sh-cbar-fill]').style, 'width', Math.min(100, fill * 100) + '%');
    set(document.querySelector('[data-sh-addons-title]'), 'textContent', title);
  }

  function paint() {
    fillAmounts();
    drawBar(); // first: tier boxes read the cart subtotal from the bar
    drawTiers();
    draw30();
  }
  window.shPaint = paint; // set-choice / quick-add call it after changing prices

  function render(res) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res.sections) return (window.location = window.routes.cart_url);
    drawer.classList.remove('is-empty');
    drawer.renderContents({ sections: res.sections });
  }

  function post(url, body) {
    var drawer = document.querySelector('cart-drawer');
    // ask for the drawer HTML in the same request, so no second round trip
    if (drawer) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-sh-upgrade]');
    var add = e.target.closest('[data-sh-addon]');
    if (!up && !add) return;
    e.preventDefault();
    var btn = up || add;
    btn.disabled = true;
    var job;
    if (up) {
      // one request: bracelet line -1 (by line key), set +1 (by variant id, absolute qty)
      var updates = {};
      updates[up.dataset.key] = Number(up.dataset.qty) - 1;
      updates[up.dataset.set] = Number(up.dataset.setQty || 0) + 1;
      job = post(window.routes.cart_update_url + '.js', { updates: updates });
    } else {
      job = post(window.routes.cart_add_url + '.js', { items: [{ id: Number(add.dataset.shAddon), quantity: 1 }] });
    }
    job.then(render).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Try again';
      console.error(err);
    });
  });

  // +/− in the drawer: move the bar at once from the line's unit price; the server reply redraws it
  document.addEventListener('click', function (e) {
    var b = e.target.closest('cart-drawer .quantity__button');
    var bar = document.querySelector('[data-sh-cbar]');
    var row = b && b.closest('[data-unit]');
    if (!row || !bar || b.disabled) return;
    var input = row.querySelector('.quantity__input');
    if (b.name === 'minus' && Number(input.value) <= Number(input.min || 0)) return;
    var step = Number(input.step) || 1;
    var delta = (b.name === 'plus' ? step : -step) * Number(row.dataset.unit);
    bar.dataset.sub = Math.max(0, Number(bar.dataset.sub) + delta);
    bar.dataset.total = Math.max(0, Number(bar.dataset.total) + delta);
    drawBar();
  });

  // Add to cart: open the drawer straight away with an "Adding…" line; renderContents fills it.
  // ponytail: total/bar wait for the server; the line shows a placeholder until then.
  window.shCartPending = function (on) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (on === false) {
      drawer.classList.remove('is-adding');
      return drawer.close();
    }
    drawer.classList.add('is-adding');
    drawer.open();
  };
  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    var original = proto.renderContents;
    proto.renderContents = function (state) {
      this.classList.remove('is-adding');
      return original.call(this, state);
    };
  });

  function watch() {
    paint();
    new MutationObserver(paint).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
